function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getIntervalIndexes = (startsAt, endsAt, gridBreakpoints) => {
  var starts = gridBreakpoints.indexOf(startsAt);
  var ends = gridBreakpoints.indexOf(endsAt) + 1;
  return [starts, ends];
};

export var makeGridSystemInterval = _ref => {
  var {
    columns,
    margin,
    gutter,
    startsAt,
    endsAt,
    gridBreakpoints
  } = _ref;
  var [starts, ends] = getIntervalIndexes(startsAt, endsAt, gridBreakpoints);
  return gridBreakpoints.slice(starts, ends).reduce((breakpointsAccumulator, currentBreakpoint) => _objectSpread(_objectSpread({}, breakpointsAccumulator), {}, {
    [currentBreakpoint]: {
      columns,
      margin,
      gutter
    }
  }), {});
};
export var getColumnIntervals = column => Object.keys(column).reduce((acum, curr) => {
  var isInterval = curr.includes('-');
  if (!isInterval || !column[curr]) return acum;
  var [end, start] = curr.split('-');
  var interval = [start, end, column[curr] || 1];
  return [...acum, interval];
}, []);
export var columnFromIntervals = (intervals, gridBreakpoints) => {
  var column = {};
  intervals.forEach(interval => {
    var [startsAt, endsAt, columns] = interval;
    var [starts, ends] = getIntervalIndexes(startsAt, endsAt, gridBreakpoints);
    var intervalBreakpoints = gridBreakpoints.slice(starts, ends);
    intervalBreakpoints.forEach(breakpoint => {
      column[breakpoint] = columns;
    });
  });
  return column;
};
//# sourceMappingURL=Grid.utils.js.map